import { CurrencySelector } from '../../../../components/selects/CurrencySelector';
import { EditorProps } from '../types/editor-props';

/**
 * Dropdown editor for ISO 4217 currency codes.
 * Options come from `ReferenceDataProvider` (GraphQL-fed in apps,
 * fixture-fed in Storybook). Picking a value commits immediately.
 */
export function CurrencyEditor({ id, value, onChange, onCommit, onBlur }: EditorProps) {
  return (
    <CurrencySelector
      id={id}
      isSearchable
      defaultOpen
      value={value == null ? '' : String(value)}
      onChange={code => {
        if (onCommit) onCommit(code);
        else onChange(code);
      }}
      onBlur={onBlur}
      autoFocus
    />
  );
}
